import i18n from "../i18n/config";

const SUPPORTED = new Set(["tr", "en", "fr"]);

/** Query param for API Excel exports — matches backend resolveExportLang. */
export function getExportLangParam() {
  const raw = (i18n.language || "tr").split("-")[0].toLowerCase();
  return { lang: SUPPORTED.has(raw) ? raw : "tr" };
}

/** Merge export language into filters / request params. */
export function withExportLang(params = {}) {
  return { ...params, ...getExportLangParam() };
}
